/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TerminatedInputs */

const cs_enum_terminated = /** @type {(inputs: Enum_TerminatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukončeno`)
};

const en_enum_terminated = /** @type {(inputs: Enum_TerminatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminated`)
};

/**
* | output |
* | --- |
* | "Terminated" |
*
* @param {Enum_TerminatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_terminated = /** @type {((inputs?: Enum_TerminatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TerminatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_terminated(inputs)
	return cs_enum_terminated(inputs)
});